$().fancybox({
    selector : '.lightbox',
    buttons: ["zoom", "download", "close"],
    afterClose: function() {
        var $swiperContainer = this.$thumb.closest('.swiper-container')
        if ($swiperContainer.length > 0) {
            var key = null
            var stopedSlide = 0
            $swiperContainer.find('.swiper-slide img').each((i, el) => {
                if ($(el).attr('src') === this.$thumb.attr('src')) {
                    stopedSlide = i
                }
            })

            $swiperContainer[0].classList.forEach(cls => {
                if (cls.indexOf('js-swiper--work-') >= 0) {
                    key = parseInt(cls.split('work-')[1])
                }
            })

            if (key !== null && arWorkSwiper.length) {
                var swiperObj = arWorkSwiper.find(obj => obj.key === key)
    
                // HACK for reinit swiper
                swiperObj.swiper.slideTo(swiperObj.swiper.slides.length, 0)
                swiperObj.swiper.slideTo(stopedSlide, 0)
            }
        }
    }
});


// WEBPACK FOOTER //
// ./frontend/components/modal/modal.js